module.exports = __webpack_public_path__ + "static/media/vehicleregistrationback.35fd1e06.svg";